/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_Order_4Inputs */

const en_flow_order_4 = /** @type {(inputs: Flow_Order_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The warehouse ships it.`)
};

/**
* | output |
* | --- |
* | "The warehouse ships it." |
*
* @param {Flow_Order_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_order_4 = /** @type {((inputs?: Flow_Order_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_Order_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_order_4(inputs)
});